export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-search-db812017153e5c897a73274874932bbc.svg";